import { sity, rubrics, gearboxes, engines } from 'shared/modules/subjectiveText/allText';
import { getSeoDataByParams } from 'shared/helpers/seoTextFinder';

import FIRST_RUBRICS_TYPES from 'shared/constants/json/firstSeoRubricsTypes.json';
import SECOND_RUBRICS_TYPES from 'shared/constants/json/secondSeoRubricsTypes.json';
import {
  replaceToUpperCase,
  replaceTransport,
  buildInGenitiveCityHeader,
  buildDriveValue,
  replaceToLowerCase,
} from 'shared/modules';

export const buildSearchAvtoSeoTitle = (data, t) => {
  const seoData = getSeoDataByParams(data, t);
  if (seoData && seoData.title) return seoData.title;

  const {
    make = '',
    model = '',
    location = '',
    generation = '',
    gearbox = '',
    engine = '',
    body = '',
    drive: driveSelected = '',
    isNew = false,
    year: yearSelected = '',
    country = null,
    city = null,
  } = data;

  const drive = buildDriveValue(driveSelected, t);
  const locale = t('locale');
  const inGenitiveLocation =
    location && sity[location]
      ? buildInGenitiveCityHeader(sity[location][locale].genitive)
      : (city &&
          city.title &&
          ` ${buildInGenitiveCityHeader(city[`${locale}_title`] || city.title)}`) ||
        `в ${sity['Украина'][locale].genitive}`;

  const yearVsSpace = yearSelected ? ` ${yearSelected} ${t('года')}` : '';
  const customGearbox = gearbox in gearboxes ? gearboxes[gearbox][locale].title : gearbox;
  const customEngine = engine in engines ? engines[engine][locale].title : engine;
  const customEngineAlt = engine in engines ? engines[engine][locale].altTitle : engine;

  const countryTitle = country && t(country.title);
  const countryFromTitle = country && country.from && country.from[locale];

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_TITLE_AVTO_COUNTRY', { countryTitle, countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(
      isNew
        ? 'Продажа {make}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге'
        : 'Продажа {make}{year} б/у на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(
      isNew
        ? 'Продажа {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге'
        : 'Продажа б/у {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'Продажа {make} {model} {body}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге'
        : 'Продажа б/у {body} {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'Продажа {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге'
        : 'Продажа б/у {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'Новый {make} {model}{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™'
        : '{make} {model} б/у{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™',
      {
        ...data,
        generation: ` ${generation}` || '',
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }
  if (make && model && gearbox && drive && !engine) {
    return t(
      isNew
        ? 'Новый {make} {model}{generation} {gearbox} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™'
        : 'Купить {make} {model}{generation} {gearbox} {drive}{year} {inGenitiveLocation} на АвтоБазар™',
      {
        ...data,
        generation: ` ${generation}` || '',
        inGenitiveLocation,
        drive,
        year: yearVsSpace,
      },
    );
  }
  if (make && model && gearbox && drive && engine) {
    return t(
      isNew
        ? 'Новый {make} {model} {engine} {gearbox}{generation} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™'
        : '{make} {model} {engine} {gearbox} {drive}{generation}{year} б/у купить {inGenitiveLocation} на АвтоБазар™',
      {
        ...data,
        generation: ` ${generation}` || '',
        inGenitiveLocation,
        drive,
        year: yearVsSpace,
      },
    );
  }

  if (make && !model && gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'АвтоБазар™ {inGenitiveLocation} – купить новое авто {makeTranslate} {customGearbox}{year} по лучшей цене'
        : 'АвтоБазар™ {inGenitiveLocation} – купить авто {makeTranslate} {customGearbox}{year} б/у по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
        customGearbox,
      },
    );
  }

  if (!make && !model && !gearbox && engine && !drive) {
    return t(
      isNew
        ? 'АвтоБазар™ {inGenitiveLocation} – купить новый {customEngine}{year} по лучшей цене'
        : 'АвтоБазар™ {inGenitiveLocation} – купить {customEngine}{year} б/у по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
        customEngine,
      },
    );
  }

  if (!make && !model && !gearbox && !engine && !drive && body) {
    return t(
      isNew
        ? 'АвтоБазар™ {inGenitiveLocation} – купить новый авто {body}{year} по лучшей цене'
        : 'АвтоБазар™ {inGenitiveLocation} – купить авто {body}{year} б/у по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }

  if (make && !model && !gearbox && engine && !drive && !body) {
    return t(
      isNew
        ? 'Новые {customEngineAlt} {make}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}'
        : '{customEngineAlt} {make}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
        customEngineAlt,
      },
    );
  }

  if (make && model && !gearbox && engine && !drive && !body) {
    return t(
      isNew
        ? 'Новые {customEngineAlt} {make} {model}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}'
        : '{customEngineAlt} {make} {model}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
        customEngineAlt,
      },
    );
  }

  if (!make && !model && gearbox && !engine && !drive && !body) {
    return t(
      isNew
        ? 'АвтоБазар™ {inGenitiveLocation} - купить новый авто {customGearbox}{year} по лучшей цене'
        : 'АвтоБазар™ {inGenitiveLocation} - купить авто {customGearbox}{year} б/у по лучшей цене',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
        customGearbox,
      },
    );
  }
  if (make && !model && !gearbox && !engine && !drive && body) {
    return t(
      isNew
        ? 'Новый {body} {make}{year} - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}'
        : '{body} {make}{year} б/у - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}',
      {
        ...data,
        inGenitiveLocation,
        year: yearVsSpace,
      },
    );
  }

  return t(
    isNew
      ? 'АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль новый, сравнение цен в каталоге'
      : 'Автобазар {inGenitiveLocation}. Купить авто бу {inGenitiveLocation} с пробегом на авторынке',
    {
      inGenitiveLocation,
      location,
    },
  );
};

export const buildDealersSeoTitle = (data, slug, t) => {
  const {
    make = '',
    model = '',
    makeTranslate = make,
    modelTranslate = model,
    location: locationRu = '',
  } = data;

  const seoData = getSeoDataByParams(
    { ...data, transport: data.transport || slug },
    t,
    'avtosalony',
  );
  if (seoData && seoData.title) return seoData.title;

  const locale = t('locale');

  const cityHeader = locationRu && sity[locationRu] ? locationRu : 'Украина';
  const location = locationRu && t(locationRu);
  const accusativeCityHeader = sity[cityHeader][locale].accusative;
  const inGenitiveCityHeader = buildInGenitiveCityHeader(sity[cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t(
        'Автосалоны {location} – надежные автодилеры, цены, акции на авто из салона – АвтоБазар™',
        { location },
      );
    }
    if (make && !location && !model) {
      return t('Автосалоны {make} – официальные дилеры {makeTranslate} на сайте АвтоБазар™', {
        make,
        makeTranslate,
      });
    }
    if (make && location && !model) {
      return t(
        'Автосалоны {make} – цены салонов {makeTranslate} {inGenitiveCityHeader} на сайте АвтоБазар™',
        {
          make,
          makeTranslate,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model && !location) {
      return t(
        '{make} {model} купить в автосалонах – цены на {makeTranslate} {modelTranslate} – АвтоБазар™',
        {
          make,
          model,
          makeTranslate,
          modelTranslate,
        },
      );
    }
    if (make && model && location) {
      return t(
        'Продажа {make} {model} в автосалонах {accusativeCityHeader}. Сравнение цен авто дилеров на {modelTranslate} – АвтоБазар™',
        {
          make,
          model,
          modelTranslate,
          accusativeCityHeader,
        },
      );
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t(
        'Мотосалоны {location} – лучшие цены мото магазинов: мотоциклы, скутеры, квадроциклы – АвтоБазар™',
        { location },
      );
    }
    if (make && !location) {
      return t(
        'Мотосалоны {make} – все официальные мото магазины {makeTranslate} на сайте АвтоБазар™',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (make && location) {
      return t('Мотосалоны {make} {location} – все официальные мото магазини на сайте АвтоБазар™', {
        make,
        makeTranslate,
        location,
      });
    }
    return t(
      'Мотосалоны Украины – цены мото магазинов на мотоциклы, скутеры, квадроциклы – АвтоБазар™',
      {},
    );
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Автосалоны автобусов {location} – надежные дилеры бусов на сайте АвтоБазар™', {
        location,
      });
    }
    if (make && !location && !model) {
      return t('Автосалоны автобусов {make} – цены дилеров на бусы {makeTranslate} – АвтоБазар™', {
        make,
        makeTranslate,
      });
    }
    if (make && location) {
      return t(
        'Автобусы {make} в автосалонах {accusativeCityHeader} – проверенные бусы {makeTranslate} на АвтоБазар™',
        {
          make,
          makeTranslate,
          accusativeCityHeader,
        },
      );
    }
    return t(
      'Автосалоны автобусов Украины – все автодилеры по продаже бусов на сайте АвтоБазар™',
      {},
    );
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t(
        'Автосалоны грузовых автомобилей {location} – надежные автодилеры грузовиков на сайте АвтоБазар™',
        { location },
      );
    }
    if (make && !location && !model) {
      return t('Автосалоны грузовых {make} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make,
        makeTranslate,
      });
    }
    if (make && location) {
      return t(
        'Грузовые {make} в автосалонах {accusativeCityHeader} – проверенные грузовики {makeTranslate} на АвтоБазар™',
        {
          make,
          makeTranslate,
          accusativeCityHeader,
        },
      );
    }
    return t(
      'Автосалоны грузовых автомобилей Украины – все автодилеры по продаже грузовиков на АвтоБазар™',
      {},
    );
  }
  if (slug === 'spetstehnika') {
    if (!make && location) {
      return t('Дилеры спецтехники {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader,
      });
    }
    if (make && !location) {
      return t('Дилеры спецтехники {make} Украины в каталоге компаний АвтоБазар™', {
        make,
        makeTranslate,
      });
    }
    return t('Дилеры спецтехники Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (!make && location) {
      return t('Дилеры водного транспорта {location} в каталоге компаний АвтоБазар™', {
        location,
      });
    }
    if (make && !location) {
      return t('Дилеры водного транспорта {make} Украины в каталоге компаний АвтоБазар™', {
        make,
        makeTranslate,
      });
    }
    return t('Дилеры водного транспорта Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (!make && location) {
      return t(
        'Производители прицепов и проверенные дилеры {inGenitiveCityHeader} – каталог компаний АвтоБазар™',
        {
          inGenitiveCityHeader,
        },
      );
    }
    if (make && !location) {
      return t('Проверенные дилеры прицепов {make} в Украине – каталог компаний на АвтоБазар™', {
        make,
        makeTranslate,
      });
    }
    return t(
      'Производители прицепов и проверенные дилеры Украины в каталоге компаний АвтоБазар™',
      {},
    );
  }

  return t('Автосалоны Украины – все автодилеры, цены, акции на авто из салона – АвтоБазар™', {});
};

export const buildFirmsSeoTitle = (data, t) => {
  const { cityTitle, section, regLocation, location } = data;
  // if (section === 'СТО') {
  //   if (regLocation)
  //     return t('СТО {location} - автосервис по ремонту авто на сайте Автобазар', {
  //       location: regLocation,
  //     });
  //   return t('Все СТО Украины, автосервисы и шиномонтажи на АвтоБазар™');
  // }
  // if (section && cityTitle) {
  //   return t('{section} в {cityTitle} на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (section) {
  //   return t('{section} в Украине на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (cityTitle) {
  //   return t('СТО {cityTitle} - автосервис по ремонту авто на сайте Автобазар', {
  //     ...data,
  //     cityTitle: t(location),
  //   });
  // }

  if (section === 'СТО' && cityTitle) {
    return t('СТО {cityTitle}. Адреса, телефоны, карта проезда - Автобазар', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t(
      'Авторазборка {cityTitle}. Каталог компаний по разбору авто (адреса, телефоны) - Автобазар',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто - Автобазар', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Телефоны, адреса компаний - Автобазар', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Дистрибьютеры автотоваров {cityTitle}. Каталог поставщиков автотоваров - Автобазар', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('ТСЦ {cityTitle}. Телефоны, адреса сервисных центров авто - Автобазар', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle}. Каталог компаний с адресами и телефонами - Автобазар', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  return t('Каталог фирм в Украине на Автобазаре - Полный каталог фирм в вашем городе');
};

export const buildSparePartsSeoTitles = (data, rubricSlug, t) => {
  const locale = t('locale');
  const {
    location: locationRu = '',
    make = '',
    model = '',
    makeTranslate = make,
    modelTranslate = model,
    transport: selectedTransport,
    rubric: rubricTitle,
    partType: partTypeRu,
    partTypeUk,
  } = data;
  const cityHeader = locationRu && sity[locationRu] ? locationRu : 'Украина';
  const location = locationRu && t(locationRu);

  const seoData = getSeoDataByParams(data, t, 'zapchasti');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  const inGenitiveCityHeader = buildInGenitiveCityHeader(sity[cityHeader][locale].genitive);

  const transport = replaceTransport(selectedTransport);

  let rubric = rubricTitle;
  let partType = partTypeRu;

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Запчасти для {make} – Купить запчасти на {transport} в Украине - АвтоБазар', {
        make,
        transport,
      });
    }
    if (make && model) {
      return t(
        'Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине - АвтоБазар',
        {
          make,
          makeTranslate,
          model,
          modelTranslate,
        },
      );
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Запчасти на {transport} {location} – купить по лучшей цене на АвтоБазар™', {
        transport,
        location,
      });
    }
    if (make && !model) {
      return t(
        'Запчасти на {transport} {make} ({makeTranslate}) {location} - лучшие цены на АвтоБазар™',
        {
          make,
          transport,
          location,
          makeTranslate,
        },
      );
    }
    if (make && model) {
      return t(
        'Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™',
        {
          make,
          makeTranslate,
          model,
          modelTranslate,
          inGenitiveCityHeader,
        },
      );
    }
  }

  if (FIRST_RUBRICS_TYPES.includes(rubricSlug) && rubric && rubrics[rubric]) {
    rubric = rubric && rubrics[rubric][locale].accusative;
  } else if (SECOND_RUBRICS_TYPES.includes(rubricSlug) && rubric && rubrics[rubric]) {
    rubric = rubric && rubrics[rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t(
        'Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить по лучшей цене - АвтоБазар™',
        {
          rubric,
          make,
          makeTranslate,
          transport,
        },
      );
    }
    if (make && model) {
      return t(
        'Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить по лучшей цене - АвтоБазар™',
        {
          rubric,
          make,
          model,
          makeTranslate,
          modelTranslate,
        },
      );
    }

    return t('Запчасти {rubric} на {transport} – купить по лучшей цене - АвтоБазар™', {
      rubric,
      transport,
    });
  }

  if (location && rubricSlug && rubric && !partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t(
        'Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™',
        {
          rubric,
          make,
          makeTranslate,
          transport,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model) {
      return t(
        'Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™',
        {
          rubric,
          make,
          model,
          makeTranslate,
          modelTranslate,
          inGenitiveCityHeader,
        },
      );
    }

    return t('Запчасти {rubric} на {transport} {location} – купить по лучшей цене - АвтоБазар™', {
      rubric,
      transport,
      location,
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить в Украине – АвтоБазар™', {
        partType,
        transport,
        make,
        makeTranslate,
      });
    }
    if (make && model) {
      return t(
        '{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™',
        {
          partType,
          make,
          model,
          makeTranslate,
          modelTranslate,
        },
      );
    }

    return t('{partType} на {transport} – купить в Украине – АвтоБазар™', {
      partType,
      transport,
    });
  }

  if (location && rubricSlug && rubric && partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);

    if (make && !model) {
      return t(
        '{partType} на {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™',
        {
          partType,
          make,
          makeTranslate,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model) {
      return t(
        '{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™',
        {
          partType,
          make,
          model,
          makeTranslate,
          modelTranslate,
          inGenitiveCityHeader,
        },
      );
    }

    return t('{partType} на {transport} – купить {inGenitiveCityHeader} – АвтоБазар™', {
      partType,
      transport,
      inGenitiveCityHeader,
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} ({makeTranslate}) купить запчасти - АвтоБазар™', {
        rubric,
        make,
        makeTranslate,
        transport,
      });
    }
    if (make && model) {
      return t(
        '{rubric} на {make} {model} ({makeTranslate} {modelTranslate}) купить на АвтоБазар™',
        {
          rubric,
          make,
          model,
          makeTranslate,
          modelTranslate,
        },
      );
    }

    return t('{rubric} на {transport} – купить запчастини - АвтоБазар™', {
      rubric,
      transport,
    });
  }

  if (location && rubricSlug && rubric && !partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} - купить {location} – АвтоБазар™', {
        rubric,
        make,
        transport,
        location,
      });
    }
    if (make && model) {
      return t('{rubric} {make} {model} – купить запчасти на {transport} {location} – АвтоБазар™', {
        rubric,
        make,
        model,
        transport,
        location,
      });
    }

    return t('{rubric} на {transport} купить {location} – АвтоБазар™', {
      rubric,
      transport,
      location,
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить – АвтоБазар™', {
        partType,
        transport,
        make,
        makeTranslate,
      });
    }
    if (make && model) {
      return t(
        '{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™',
        {
          partType,
          make,
          model,
          makeTranslate,
          modelTranslate,
        },
      );
    }

    return t('{partType} на {transport} купить в Украине – АвтоБазар™', {
      partType,
      transport,
    });
  }

  if (location && rubricSlug && rubric && partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);

    if (make && !model) {
      return t(
        '{partType} на {transport} {make} ({makeTranslate}) купить {location} – АвтоБазар™',
        {
          partType,
          make,
          makeTranslate,
          location,
          transport,
        },
      );
    }
    if (make && model) {
      return t(
        '{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить {location} – АвтоБазар™',
        {
          partType,
          make,
          model,
          makeTranslate,
          modelTranslate,
          location,
        },
      );
    }

    return t('{partType} на {transport} – купить {location} – АвтоБазар™', {
      partType,
      transport,
      location,
    });
  }

  return t('Запчасти на {transport} купить в Украине – АвтоБазар™', {
    transport,
  });
};

export const buildFirmPageSeoTitle = (title, tab, t, car_drive_countries = [], tags) => {
  if (tab === 'blog') {
    return t('{title} – Новости и акции компании на сайте Автобазар™', {
      title,
    });
  }

  const countries = car_drive_countries.map(item => item.title).join(', ');

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по пригону авто из {countries} - Автобазар', {
      title,
      countries,
    });
  }

  if (Array.isArray(tags)) {
    for (let i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефоны, график работы - Автобазар', {
          title,
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Адрес, телефоны, график работы - Автобазар', {
          title,
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Адрес, телефон, график работы компании - Автобазар', {
          title,
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t(
          'Дистрибьютер автотоваров {title}. Адрес, телефон, график работы компании - Автобазар',
          {
            title,
          },
        );
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон сервисного центра - Автобазар', {
          title,
        });
      }
    }
  }

  return t('METATEGS_TITLE_FIRM_ZAPCHASTI', { title });
};

export const buildSearchMotoSeoTitle = (data, t) => {
  const seoData = getSeoDataByParams(data, t);
  if (seoData && seoData.title) {
    return seoData.title;
  }

  const {
    category = '',
    type = '',
    make = '',
    model = '',
    locationWhere,
    motoTitle,
    yearTitle,
  } = data;
  return [
    t('Купить'),
    motoTitle || category || type
      ? `${motoTitle || (type && type.title ? type.title.toLowerCase() : '')} ${category &&
        category.title
          ? category.title.toLowerCase()
          : ''} `
      : t('мототехнику'),
    make && make.title,
    model && model.title,
    `${yearTitle || ''}${locationWhere || t('в Украине')}:`,
    t('б/у и новая мототехника на АвтоБазар™'),
  ]
    .filter(i => !!i)
    .join(' ');
};

export const buildSearchCommercialSeoTitle = (params, t) => {
  const data = params;

  const seoData = getSeoDataByParams(data, t, 'commercial');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  const isUkraine = ['Україні', 'Украине'].includes(data.cityTitle);
  if (!isUkraine) {
    data.cityTitle = `${t('в')} ${t(data.cityTitle)}`;
  } else data.cityTitle = `в ${t('Украине')}`;

  const {
    transportTitle,
    transportNextTitle,
    make,
    model,
    isNew,
    transportType,
    transportCategoryTitle,
  } = data;

  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Автобусы {transportCategoryTitle} б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Мототехника б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('{transportCategoryTitle} б/у и новые купить {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t(
      '{transportCategoryTitle} - купить б/у и новую спецтехнику {cityTitle} на АвтоБазар™',
      data,
    );
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t(
      '{transportCategoryTitle} - купить водный транспорт б/у и новый {cityTitle} на АвтоБазар™',
      data,
    );
  }
  if (transportTitle && make && model && isNew) {
    return t(
      'Новый {make} {model} {yearTitle}купить {cityTitle}: {makeTranslit} {modelTranslit} на Автобазаре',
      {
        ...data,
        transportTitle: replaceToLowerCase(transportTitle),
        transportNextTitle: replaceToLowerCase(transportNextTitle),
      },
    );
  }

  if (transportTitle && make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t(
        'Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    if (transportType === 'spetstehnika') {
      return t(
        'Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    return t(
      'Купить новый {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре',
      {
        ...data,
        transportTitle: replaceToLowerCase(transportTitle),
        transportNextTitle: replaceToLowerCase(transportNextTitle),
      },
    );
  }
  if (transportTitle && make && model && !isNew) {
    return t(
      '{make} {model} {yearTitle}купить {cityTitle}: б/у и новые {makeTranslit} {modelTranslit} на Автобазаре',
      data,
    );
  }
  if (transportTitle && make && !model && !isNew) {
    if (transportType === 'spetstehnika') {
      return t(
        'Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} {makeTranslit} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    if (transportType === 'avtobus') {
      return t(
        'Автобусы {make} {makeTranslit} б/у {yearTitle}{cityTitle} купить на АвтоБазар™',
        // 'Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    return t(
      'Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} {makeTranslit} на Автобазаре',
      {
        ...data,
        transportTitle: replaceToLowerCase(transportTitle),
        transportNextTitle: replaceToLowerCase(transportNextTitle),
      },
    );
  }
  if (transportTitle && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t(
        'Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} авто на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    if (transportType === 'avtobus') {
      return t(
        'Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    if (transportType === 'spetstehnika') {
      return t(
        'Купить новую {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    return t(
      'Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре',
      {
        ...data,
        transportTitle: replaceToLowerCase(transportTitle),
        transportNextTitle: replaceToLowerCase(transportNextTitle),
      },
    );
  }
  if (transportTitle && !make && !model && !isNew) {
    if (transportTitle === t('коммерческий транспорт')) {
      return t(
        'Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая техника на Автобазар™',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
        },
      );
    }
    if (transportType === 'gruzovye') {
      return t(
        'Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    if (transportType === 'avtobus') {
      return t(
        'Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    if (transportType === 'spetstehnika') {
      return t(
        'Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая {transportNextTitle} на Автобазаре',
        {
          ...data,
          transportTitle: replaceToLowerCase(transportTitle),
          transportNextTitle: replaceToLowerCase(transportNextTitle),
        },
      );
    }
    return t(
      'Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре',
      {
        ...data,
        transportTitle: replaceToLowerCase(transportTitle),
        transportNextTitle: replaceToLowerCase(transportNextTitle),
      },
    );
  }
  return t('Купить {cityTitle}: б/у и новые авто на Автобазаре');
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTitles.js